import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gdx-page-under-construction',
    templateUrl: './page-under-construction.component.html',
    standalone: false
})
export class PageUnderConstructionComponent {}
